import * as Validators from '../../utils/forms/validators';
import { residentialPropTypes, LeaseTerms, FurnishingChoices, commercialPropTypes, REQUIRES_BUILDING, ConditionChoices, MinimumRentalPrice, MinimumSalePrice} from '../../../constants/properties';


export const ownerReceipt: Validators.Validator = (field, form) => {
  if (field.value != '1' && field.value != '0') {
    field.isValid = false;
    form.isValid = false;
    return false;
  }
}

export const minLeaseTerm: Validators.Validator = (field, form) => {
  if (form.fields['category'].value == 'Rent') {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const rentalPrice: Validators.Validator = (field, form) => {
  if (form.fields['category'].value == 'Rent' && 
      form.fields['division'].value === 'Residential') {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    } else if (field.value < MinimumRentalPrice) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const salePrice: Validators.Validator = (field, form) => {
  if (form.fields['category'].value == 'Sale' && 
      form.fields['division'].value === 'Residential') {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    } else if (field.value < MinimumSalePrice) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const discountedPrice: Validators.Validator = (field, form) => {
  let maxprice = form.fields['salePrice'].value;
  let minprice = MinimumSalePrice;
  if (form.fields['category'].value == 'Rent') {
    maxprice = form.fields['rentalPrice'].value;
    minprice = MinimumRentalPrice;
  };
  if (field.value != "") {
    if (field.value < minprice) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    } else if (field.value > maxprice) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    };
  };
}

export const pricePerSqm: Validators.Validator = (field, form) => {
  if (form.fields['division'].value === 'Commercial') {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    } else if (field.value) {
      let area;

      if (form.fields['type'].value != 'Commercial Space' && 
          form.fields['type'].value != 'Office Space' && 
          form.fields['type'].value != 'Serviced Office') {
        area = form.fields['lotArea'].value;
      } else {
        area = form.fields['floorArea'].value;
      }

      const calculatedRentalPrice = area * field.value;
      
      if (calculatedRentalPrice < MinimumRentalPrice) {
        field.isPristine = false;
        field.isValid = false;
        form.isValid = false;
        return false;
      }
    }
  }
}

export const associationDuesIncluded: Validators.Validator = (field, form) => {
  if (form.fields['category'].value == 'Rent') {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const associationDues: Validators.Validator = (field, form) => {
  if (form.fields['associationDuesIncluded'].value == 0) {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const floorArea: Validators.Validator = (field, form) => {
  if (form.fields['type'].value !== 'Vacant Lot' && 
      form.fields['type'].value !== 'Commercial Lot') {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const lotArea: Validators.Validator = (field, form) => {
  if (form.fields['type'].value != 'Condominium' && 
      form.fields['type'].value != 'Commercial Space' && 
      form.fields['type'].value != 'Office Space' && 
      form.fields['type'].value != 'Serviced Office') {

    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }

  }
}

export const furnished: Validators.Validator = (field, form) => {
  const { division, type } = form.fields;

  if (division.value == 'Residential' && type.value != 'Vacant Lot') {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const condition: Validators.Validator = (field, form) => {
  if (form.fields['division'].value == 'Commercial') {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const bedrooms: Validators.Validator = (field, form) => {
  const { division, type } = form.fields;

  if (division.value == 'Residential' && type.value != 'Vacant Lot') {
    if (!field.value && field.value != 0) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;

      return false;
    }
  }
}

export const bathrooms: Validators.Validator = (field, form) => {
  const { division, type } = form.fields;

  if (division.value == 'Residential' && type.value != 'Vacant Lot') {
    if (!field.value && field.value != 0) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}

export const parkingSpaces: Validators.Validator = (field, form) => {
  if (form.fields['__hasParking'].value) {
    if (!field.value) {
      field.isPristine = false;
      field.isValid = false;
      form.isValid = false;
      return false;
    }
  }
}